import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";

const heroImage = {
  url: `${process.env.CDN_URL}/images/policies-hero-image.jpg`,
  alt: 'Deposit Policies Hero Image'
};

const DepositPoliciesTemplate = ({ pageContext: { locale, activeTab, pageSlug } }) => {
  const intl = useIntl();

  const tabs = {
    'security-deposit': {
      title: intl.formatMessage({ id: 'Security Deposit' }),
      components: [() => intl.formatMessage({ id: 'Security Deposit text' })]
    },
    'holding-deposit': {
      title: intl.formatMessage({ id: 'Holding Deposit' }),
      components: [() => intl.formatMessage({ id: 'Holding Deposit text' })]
    },
  };

  return (
    <Fragment>
      <CustomSEO image={heroImage} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={intl.formatMessage({ id: 'Deposit Policies' })}
        heroImage={heroImage}
        lazyload={false}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Fragment>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({id: 'Deposit Policies'})} - ${title}`;
  const metaDescription = `${intl.formatMessage({id: 'Security Deposit, Holding Deposit'})}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default DepositPoliciesTemplate;
